import { TableColumnType } from 'src/types/table';

export const allColumns: TableColumnType[] = [
    {
        key: 'ID',
        label: 'id',
        type: 'number',
        defaultShow: true,
    },
    {
        key: 'STATUS',
        label: 'status',
        defaultShow: true,
        type: 'select',
        selectOption: 'productCompletionSheetStatusCodes',
    },
    {
        key: 'CREATED_AT',
        label: 'createdAt',
        defaultShow: true,
        type: 'dateTime',
    },
    {
        key: 'COMPLETED_UNTIL',
        label: 'completedUntil',
        defaultShow: true,
        type: 'dateTime',
    },
];
